import { render, staticRenderFns } from "./ModalRestoreUser.vue?vue&type=template&id=564c991f&"
import script from "./ModalRestoreUser.vue?vue&type=script&lang=js&"
export * from "./ModalRestoreUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports